module.exports = __webpack_public_path__ + "static/media/cyberark-dark.d5f4d12b.png";